var exports = {
  "kL": "AudioPlayer.module__container___Mzc5Ul",
  "Md": "AudioPlayer.module__fileName___Mzc5Ul",
  "NE": "AudioPlayer.module__progressSection___Mzc5Ul",
  "hr": "AudioPlayer.module__progressBar___Mzc5Ul",
  "Ey": "AudioPlayer.module__timeDisplay___Mzc5Ul",
  "ne": "AudioPlayer.module__controls___Mzc5Ul",
  "gm": "AudioPlayer.module__mainControls___Mzc5Ul",
  "Rr": "AudioPlayer.module__playButton___Mzc5Ul",
  "$3": "AudioPlayer.module__seekButton___Mzc5Ul",
  "f6": "AudioPlayer.module__secondaryControls___Mzc5Ul",
  "Wq": "AudioPlayer.module__volumeControl___Mzc5Ul",
  "Sn": "AudioPlayer.module__playbackRate___Mzc5Ul",
  "Hw": "AudioPlayer.module__mobile___Mzc5Ul",
  "t0": "AudioPlayer.module__spin___Mzc5Ul",
};

module.exports = exports;
